import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Returns the default home route for a given role.
 * - ProductSyncOperator/Viewer → /product-replicator
 * - AlloraSyncOperator/Viewer  → /allora-integration
 * - All others                 → /monitor
 */
function getDefaultRoute(role: string): string {
    if (role === 'ProductSyncOperator' || role === 'ProductSyncViewer') {
        return '/product-replicator';
    }
    if (role === 'AlloraSyncOperator' || role === 'AlloraSyncViewer') {
        return '/allora-integration';
    }
    return '/monitor';
}

export const authGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (!authService.isAuthenticated()) {
        router.navigate(['/login']);
        return false;
    }

    const allowedRoles = route.data['roles'] as Array<string>;
    if (allowedRoles && !authService.hasRole(allowedRoles)) {
        const role = authService.currentUser()?.role ?? '';
        const homeRoute = getDefaultRoute(role);
        const targetUrl = state.url.split('?')[0];

        // If the user is already being redirected to their own home route
        // and still can't access it, log them out to avoid redirect loops.
        if (targetUrl === homeRoute) {
            authService.logout();
            return false;
        }

        router.navigate([homeRoute]);
        return false;
    }

    return true;
};
